import * as type from './constant';

export const getTaskCategory = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getTaskCategorySuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getTaskCategoryError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addTaskCategory = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addTaskCategorySuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateTaskCategory = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateTaskCategorySuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteTaskCategory = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteTaskCategorySuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationTaskCategoryError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
